import { render, staticRenderFns } from "./EfsFeeCategoryDictModal.vue?vue&type=template&id=127ffc2e&"
import script from "./EfsFeeCategoryDictModal.vue?vue&type=script&lang=js&"
export * from "./EfsFeeCategoryDictModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports